import React from 'react'
import Accests from '../../../src/assets/img/accepted.png'
import axios from 'axios'

export default function ApplePayDataCap() {
    const tokenCallback = () => {
        const payload = {
            'Account': '4761731000000043',
            'ExpirationMonth': '12',
            'ExpirationYear': '2024',
            'CVV': '123'
        }
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'b3a3dc81ed2a4b06b1d57ae819fcb9d6'
        }
        axios.post('https://token-cert.dcap.com/v1/otu', payload, { headers }).then(response => console.timeLog(response?.data))
    }

    // const finalCall = (tokenResponse) => {
    //     return new Promise((resolve, reject) => {
    //         // Token error!
    //         if (tokenResponse.Error) {
    //             alert('Token error: ' + tokenResponse.Error)
    //             return
    //         }

    //         // Good token! Send it to POS server for payment processing
    //         fetch('https://your-server-for-receiving-order-info/', { method: 'POST', body: JSON.stringify(tokenResponse) }).then((paymentResponse) => {
    //             paymentResponse.json().then((json) => {
    //                 console.log('json', json)
    //                 // Use Datacap's Pay API HTTP status 
    //                 // to determine how to return promise 
    //                 if (paymentResponse.status !== 200) {
    //                     reject('Error' + json.Message)
    //                 } else {
    //                     resolve('Approved' + json.Message)
    //                 }
    //             })
    //         })
    //     })
    // }


    return <form id="payment_form">
        <div className='container container-table'>
            <div className="row vertical-center-row">
                <div className="row">
                    <h3 className="col panel-title ">Payment Details</h3>
                    <img className="col img-responsive pull-right" src={Accests} />
                </div>
                <div className="panel-body">
                    <form id="payment_form">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="form-group">
                                    <label htmlFor="cardNumber">Card Number</label>
                                    <div className="input-group d-flex">
                                        <input type="tel" className="form-control" data-token="card_number" placeholder="Valid Card Number" required="" autoFocus="" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                        <span className="input-group-text" id="basic-addon2" style={{border:'1px solid #212529 !important'}}><i className="fa fa-credit-card"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-md-4">
                                <div className="form-group">
                                    <label>Exp Month</label>
                                    <input type="tel" className="form-control" data-token="exp_month" placeholder="MM" maxLength="2" required="" />
                                </div>
                            </div>
                            <div className="col-xs-4 col-md-4">
                                <div className="form-group">
                                    <label>Exp Year</label>
                                    <input type="tel" className="form-control" data-token="exp_year" placeholder="YYYY" maxLength="4" required="" />
                                </div>
                            </div>
                            <div className="col-xs-4 col-md-4 pull-right">
                                <div className="form-group">
                                    <label>CVV Code</label>
                                    <input type="tel" className="form-control" data-token="cvv" placeholder="CVV" maxLength="4" required="" />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: '20px' }}>
                            <button id="pay_button" className="btn btn-success btn-lg btn-block" type="button" onClick={tokenCallback}>Tokenize</button>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <h3>Token: </h3>
                                <p className="payment-errors text-center" id="payment_errors"></p>
                                <p className="text-center" style={{ wordBreak: 'break-all' }} id="payment_token_text"></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <input type="hidden" id="token" />
            <input type="hidden" id="payment_token" />
            <div className="apple-pay-button" />
        </div>
    </form>
}